(function() {
	'use strict'

	angular.module('ShargoApp')

		.constant('_', _)

		.service('toolsService', function($q) {

			this.isEmpty = function(obj){
				if (obj == null || obj === undefined){
					return true;
				}

				if (obj.length && obj.length > 0){
					return false;
				}
				if (obj.length === 0){
					return true;
				}

				for (var key in obj) {
					if (hasOwnProperty.call(obj, key)){
						return false;
					}
				}

				return true;
			};

			this.isEmptyJson = function(aJson) {
			    return JSON.stringify(aJson) == "{}";
            };

            this.getRandomColor = function() {
                var allowed = "0369cf".split( '' ), s = "#";
                while ( s.length < 4 ) {
                   s += allowed.splice( Math.floor( ( Math.random() * allowed.length ) ), 1 );
                }
                return s;
            };


            this.replaceAt = function(s, index, character) {
                return s.substr(0, index) + character + s.substr(index+character.length);
            };


            this.allFalse = function(obj) {
				var b = false;
				angular.forEach(obj, function(value){
					if (value) b = true;
				});
				return b;
			};

			function setFalse(obj) {
				angular.forEach(obj, function(value, key){
					if (angular.isObject(obj[key])) {
						setFalse(obj[key]);
					}
					else obj[key] = false;
				});
			}
			
			this.setFalse = setFalse;
			

			this.retryPromise = function(fn, cfg, times, step) {
                var counter = 0;
                var delay = 0;
                var _times = times ? times : 2;
                var _step = _step ? step : 1000;
                var _cfg = cfg ? cfg : {};
                var deferred = $q.defer();

                var makeRequest = function (__cfg) {
                    var args = arguments;
                    counter++;
                    delay += _step;
                    var self = this;

                    fn(__cfg).then(function(result) {
                        deferred.resolve(result);
                    }, function(e) {
                        if(counter >= _times) {
                            console.log("DEBUG retryPromise fails with counter (",counter,") and error: ", e);
                            return deferred.reject(e);
                        }
                        setTimeout(function() {
                            makeRequest.apply(self, args);
                        }, delay);
                    });
                };
                makeRequest(_cfg);
                return deferred.promise;
            }
		})

        .filter("htmlSafe", ['$sce', function($sce) {
            return function(htmlCode){
                return $sce.trustAsHtml(htmlCode);
            };
        }]);

	angular.module('mcApp.interpol', [])

        .config(function($provide) {
            $provide.decorator('ngModelDirective', function($delegate) {
                var ngModel = $delegate[0], controller = ngModel.controller;
                ngModel.controller = ['$scope', '$element', '$attrs', '$injector', function(scope, element, attrs, $injector) {
                    var $interpolate = $injector.get('$interpolate');
                    attrs.$set('name', $interpolate(attrs.name || '')(scope));
                    $injector.invoke(controller, this, {
                        '$scope': scope,
                        '$element': element,
                        '$attrs': attrs
                    });
                }];
                return $delegate;
            });
            $provide.decorator('formDirective', function($delegate) {
                var form = $delegate[0], controller = form.controller;
                form.controller = ['$scope', '$element', '$attrs', '$injector', function(scope, element, attrs, $injector) {
                    var $interpolate = $injector.get('$interpolate');
                    attrs.$set('name', $interpolate(attrs.name || attrs.ngForm || '')(scope));
                    $injector.invoke(controller, this, {
                        '$scope': scope,
                        '$element': element,
                        '$attrs': attrs
                    });
                }];
                return $delegate;
            });
        });
})();